'use client';

import { useAuth0 } from '@/contexts/Auth0Context';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export const useAuth = () => {
  const { session, isLoading, isAuthenticated, login, logout } = useAuth0();
  
  return {
    user: session?.user,
    isLoading,
    isAuthenticated,
    isAdmin: session?.user?.email?.includes('admin'), // Simplified admin check
    login,
    logout,
  };
};

export const useRequireAuth = () => {
  const { user, isLoading, isAuthenticated } = useAuth();
  const router = useRouter();
  
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      router.push('/api/auth/login');
    }
  }, [isLoading, isAuthenticated, router]);
  
  return { user, isLoading };
};
